import { Dropdown } from "react-bootstrap"
import { DataTableFilter, DataTableFilterButton, DataTableFilterData } from "./Components"
import { useTranslation } from "react-i18next"
import { forwardRef, useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortAmountDownAlt, faFilter } from '@fortawesome/free-solid-svg-icons';
import { useDataTable } from "../../hooks/useDataTable";
export const DataTableDropdown = ({sort, filter, sortAlign}) => {
    const {t} = useTranslation();
    const [column, setColumn] = useState(null);
    const [items, setItems] = useState([]);
    const {
        columns, 
        sort: sortAction, 
        sortConfig, 
        filterConfig, 
        findColumnByKey, 
        openFilterPopup, 
        clearAllFilters
    } = useDataTable();
    useEffect(() => {
        setColumn(findColumnByKey(sortConfig.key))
    }, [sortConfig])
    useEffect(() => {
        if(sort){
            setItems(columns.filter((field) => field.sort));
        }else if(filter){
            setItems(columns.filter((field) => field.filter));
        }else if(sortAlign){
            setItems([
                { key: "asc", label: t("ASC") },
                { key: "desc", label: t("DESC")}
            ])
        }
    }, [sort, filter, sortAction])
    if(items.length === 0) return null;
    const FilterButton = forwardRef(({ children, ...props }, ref) => (
        <DataTableFilterButton ref={ref} {...props}>
          {children}
        </DataTableFilterButton>
    ));
    const onClickMenu = (e, key) => {
        e.preventDefault();
        if(sort){
            sortAction(key, sortConfig.align)
        }else if(sortAlign){
            sortAction(column.key, sortConfig.align === "asc"?"desc":"asc")
        }else if(filter){
            return onFilter(key);
        }
        
    }
    const DropdownTitle = () => {
        if(sort)
            return (
                <>
                    <FontAwesomeIcon icon={faSortAmountDownAlt} /> {t("Sort By")}
                    {sortConfig.key && column && (<>: <b>{column.label !== "#"?column.label:"ID"}</b></>)}
                </>
            );
        if(filter)
            return (<><FontAwesomeIcon icon={faFilter} /> {t("Filter")}</>)
        if(sortAlign)
            return (sortConfig.align.toUpperCase());
        return null;
    }

    const onFilter = (key) => {
        openFilterPopup(findColumnByKey(key));
    }
    return (
        <DataTableFilter>
            <Dropdown>
                <Dropdown.Toggle as={FilterButton} id="dropdown-custom">
                    <DropdownTitle />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {items.map((row,index) => (
                        <Dropdown.Item key={index} className={
                            (sort)?((sortConfig.key === row.key)?"active":""):
                            (sortAlign?(sortConfig.align === row.key?"active":""):
                            (filter?(""):("")))
                        } 
                            href="#" 
                            onClick={(e) => onClickMenu(e, row.key)}
                        >
                            {row.label === "#"?t("ID"):row.label}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
            {sort && <DataTableDropdown sortAlign={true} />}
            {filter && Object.keys(filterConfig).length > 0 && (
                <DataTableFilter>
                    <DataTableFilterData $clearAll={true} onClick={(e) => clearAllFilters()}>
                        {t("Clear")}
                    </DataTableFilterData>
                </DataTableFilter>
            )}
        </DataTableFilter>
    )
}